export default "__VITE_ASSET__B8_ktE0X__"